export const HASH_KEY = 0x12345678;

export const PREFIX_VIRTUAL = '_VT_';
export const VIRTUAL_BINDINGS = '@virtual';